import {ServiceNumberModel} from '@app/models/service-number.model';
import {environment} from '@environment';
import {ServiceNumber} from '@gt-api';

export class GtServiceNumbersUtil {
  public static visibleInDisplayNumbers(serviceNumber: ServiceNumberModel): boolean {
    return environment.allowedDisplayNumberPatterns.includes(serviceNumber.pattern);
  }

  public static visibleInForwardingNumbers(serviceNumber: ServiceNumberModel): boolean {
    return environment.allowedForwardingPatterns.includes(serviceNumber.pattern);
  }

  public static isAnswerGroupNumber(serviceNumber: ServiceNumberModel | ServiceNumber): boolean {
    return serviceNumber.pattern === environment.answerGroupPattern;
  }

  public static isMainNumber(serviceNumber: ServiceNumberModel | ServiceNumber): boolean {
    return serviceNumber.pattern === environment.mainNumberPattern;
  }

  public static isMenuNumber(serviceNumber: ServiceNumberModel | ServiceNumber): boolean {
    return serviceNumber.pattern === environment.menuPattern;
  }

  public static visibleInDirectory(serviceNumber: ServiceNumberModel): boolean {
    return environment.allowedDirectoryPatterns.includes(serviceNumber.pattern);
  }

  public static visibleInCallLog(serviceNumber: ServiceNumberModel | ServiceNumber): boolean {
    return environment.allowedCallLogPatterns.includes(serviceNumber.pattern);
  }

  public static numberShouldBeVisible(serviceNumber: ServiceNumberModel | ServiceNumber): boolean {
    return environment.allowedVisibleNumberPatterns.includes(serviceNumber.pattern);
  }
}
